// extracted by mini-css-extract-plugin
export default {"qrColor":"#362044","cityCardButtons":"city-card-buttons_cityCardButtons__h4z7Y","investmentOpportunities":"city-card-buttons_investmentOpportunities__xYi+C"};